/**
 * TrackerHeldNotices — one TrackerHeldNotice per Flow Optimizer tracker of
 * this deployment; renders nothing while no tracker is held.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { useFlowOptimizerTrackers } from '@/features/trackers/flow-optimizer';

import { TrackerHeldNotice } from './TrackerHeldNotice';

export const TrackerHeldNotices: FC = () => {
  const trackers = useFlowOptimizerTrackers();
  return (
    <>
      {trackers.map((id) => (
        <TrackerHeldNotice key={id} tracker={id} />
      ))}
    </>
  );
};

export default TrackerHeldNotices;
